export default function FeatureGrid() {
  return (
    <section id="categories" className="w-full bg-background-50 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-heading text-xs md:text-sm text-foreground-500 uppercase tracking-[0.2em] font-semibold">
              itaobuy.cfd
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mt-3">
              Shop by Category
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-xs">
            Browse our curated product categories and discover trending items sourced from China&apos;s best suppliers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl min-h-[340px] flex flex-col justify-end overflow-hidden cursor-pointer transition-transform hover:-translate-y-1"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20pair%20of%20premium%20white%20leather%20sneakers%20placed%20on%20a%20warm%20terracotta%20tiled%20floor%2C%20natural%20sunlight%20creating%20soft%20angular%20shadows%2C%20minimalist%20product%20photography%2C%20clean%20contemporary%20composition%2C%20warm%20earthy%20tones%20with%20crisp%20white%20contrast&width=600&height=800&seq=feature-shoes-v2&orientation=portrait"
              alt="Shoes category"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent"></div>
            <div className="relative z-10 p-8 md:p-10">
              <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-4">
                <i className="ri-footprint-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
                Footwear
              </span>
              <h3 className="text-white text-2xl md:text-3xl font-heading font-bold">Shoes</h3>
              <p className="text-white/60 text-sm mt-1">Trending footwear collections</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl min-h-[340px] flex flex-col justify-end overflow-hidden cursor-pointer transition-transform hover:-translate-y-1"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20cozy%20oversized%20knit%20sweater%20in%20oatmeal%20beige%20draped%20over%20a%20wooden%20chair%20back%2C%20soft%20morning%20light%20through%20sheer%20linen%20curtains%2C%20warm%20intimate%20atmosphere%2C%20editorial%20fashion%20photography%2C%20creamy%20natural%20tones%20with%20gentle%20textures&width=600&height=800&seq=feature-hoodies-v2&orientation=portrait"
              alt="Hoodies and Sweaters category"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="relative z-10 p-8 md:p-10">
              <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-4">
                <i className="ri-shirt-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
                Apparel
              </span>
              <h3 className="text-white text-2xl md:text-3xl font-heading font-bold">
                Hoodies / Sweaters
              </h3>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl min-h-[340px] flex flex-col justify-between overflow-hidden cursor-pointer transition-transform hover:-translate-y-1"
          >
            <div className="p-8 md:p-10">
              <h3 className="text-foreground-950 text-2xl md:text-3xl font-heading font-bold">T-Shirts</h3>
              <p className="text-foreground-600 text-sm mt-2">Essential everyday styles</p>
            </div>
            <div className="h-48 w-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Three%20premium%20cotton%20t-shirts%20in%20charcoal%20black%20warm%20sand%20and%20dusty%20rose%20folded%20in%20perfect%20stacks%20on%20a%20light%20oak%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20clean%20minimalist%20composition%2C%20modern%20retail%20catalog%20aesthetic%2C%20harmonious%20neutral%20color%20palette&width=600&height=400&seq=feature-tshirts-v2&orientation=landscape"
                alt="T-Shirts category"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}